import { CV_PREFIX } from '@app/components/Calendars/components/CalendarView/constants';
import type { DayGridType } from '@app/components/Calendars/components/MonthGrid/types';

import '@app/components/Calendars/components/MonthGrid/styles/DayGrid.desktop.scss';

export const Grid: DayGridType = () => (
  <div className={`${CV_PREFIX}-day-grid`}></div>
);
